import axios from "../interceptos/axios_prod";

export default class EducacionService {
  async getEntrada() {
   return  await axios.get("tramite/api/v1/tramite/newEntrada?limit=20&page=1&periodo=2023&query=&id_oficina=-1&user_Id=-1");
  }

  async GenerateClave(user){
    return await axios.post("generate", user);
  }

  async RecoveryClave(user){
    return await axios.post("recovery", user);
  }

  async NewClave(user){
    return await axios.post("newclave", user);
  }


  async getTotalCantidad(){
    return await axios.get("materialresu/total_datos");
  }
}
